import React from "react";
import { BackButton } from "@/components/Common";

const DOCS: Record<string, { title: string; body: [string, string][] }> = {
  privacy: {
    title: "Informativa privacy",
    body: [
      ["Titolare", "[Ragione sociale, indirizzo, email di contatto del titolare — da completare]."],
      ["Dati raccolti", "Email, password cifrata, nome visualizzato, username, data di nascita, contenuti pubblicati, interazioni (Mi piace, commenti, visualizzazioni), indirizzo IP e identificativo del dispositivo usati per sicurezza e anti-frode."],
      ["Finalità e basi giuridiche", "Erogazione del servizio (contratto), sicurezza e prevenzione delle manipolazioni delle classifiche (legittimo interesse), invio di email di servizio come verifica e recupero password (contratto)."],
      ["Accesso con Google", "Se scegli Google riceviamo solo nome, email e foto profilo."],
      ["Conservazione", "I dati restano finché l'account è attivo; log tecnici e anti-frode per un massimo di 12 mesi."],
      ["Fornitori", "Hosting, archiviazione file, invio email transazionali. [Elenco responsabili del trattamento da completare]."],
      ["Diritti", "Accesso, rettifica, cancellazione, limitazione, portabilità, opposizione e reclamo al Garante privacy."],
      ["Minori", "L'iscrizione è riservata a chi ha almeno 16 anni."],
    ],
  },
  termini: {
    title: "Termini di servizio",
    body: [
      ["Il servizio", "UNSEEN è un social per scoprire talenti emergenti: prima il contenuto, poi chi l'ha creato."],
      ["Età", "Minimo 16 anni. Le eventuali gare con premi reali saranno riservate ai maggiorenni."],
      ["Contenuti", "Pubblichi solo contenuti di cui hai i diritti. Restano tuoi: ci concedi una licenza non esclusiva per mostrarli sulla piattaforma."],
      ["Vietato", "Spam, nudità, violenza, odio, molestie, violazioni di copyright, manipolazione dei voti con account multipli o bot."],
      ["Moderazione", "Possiamo rimuovere contenuti o sospendere account. Ogni rimozione è motivata e comunicata, come previsto dal Digital Services Act (Reg. UE 2022/2065). Puoi contestare la decisione."],
      ["Bussa e connessioni", "Le richieste sono limitate per evitare abusi. Puoi bloccare chiunque."],
    ],
  },
  regolamento: {
    title: "Regolamento UNSEEN Daily",
    body: [
      ["Durata", "Ogni gara dura un giorno e si azzera a mezzanotte (ora italiana)."],
      ["Partecipazione", "Un contenuto per persona e per gara, nuovo o già pubblicato, nella categoria della gara."],
      ["Distribuzione equa", "Ogni iscritto riceve lo stesso numero minimo di visualizzazioni valide prima di entrare in classifica."],
      ["Visualizzazione valida", "Almeno 3 secondi oppure almeno il 30% del contenuto."],
      ["Punteggio", "Mi piace validi / visualizzazioni valide 60%, completamento medio 30%, commenti pertinenti 10%. Con poche visualizzazioni il punteggio viene corretto verso la media."],
      ["Chi vota", "Account con email verificata e almeno 24 ore di anzianità. Un voto per persona."],
      ["Soglia minima", "Se i dati minimi non bastano la gara si prolunga di 24 ore una sola volta; se ancora non bastano si chiude senza vincitore."],
      ["Riconoscimento", "Il vincitore riceve un badge permanente sul profilo. Nessun premio in denaro o beni: i premi reali sono disattivati in attesa di parere legale (DPR 430/2001)."],
    ],
  },
};

export default function Legal({ doc }: { doc: "privacy" | "termini" | "regolamento" }) {
  const d = DOCS[doc];
  return (
    <div className="px-5 md:px-10 py-8 max-w-3xl" data-testid={`legal-${doc}`}>
      <BackButton parent="/" />
      <div className="border border-primary/50 p-3 text-sm my-8" data-testid="legal-draft-banner">Bozza: da far revisionare a un legale prima della pubblicazione.</div>
      <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter mb-8">{d.title}</h1>
      <div className="space-y-6">{d.body.map(([h, p]) => <section key={h}><h2 className="label text-primary mb-2">{h}</h2><p className="text-ink/80 leading-relaxed">{p}</p></section>)}</div>
    </div>
  );
}
